// Components
import './cookie-message.js' 

import './components/_animated-title'
import './components/_fade-block'
import './components/_animated-numbers'
import './components/_typewriter'
//import './components/_modal'
import './components/_menu'
import './components/_overlap-box'
import './components/_button'
import './components/_marquees3k'

// Sections
import './sections/_section-hero'
import './sections/_section-kpi'
import './sections/_section-traffic'
import './sections/_section-sites'
import './sections/_section-leads'
import './sections/_section-company'
import './sections/_section-contract'
import './sections/_section-about'

window.onload = () => {
  ScrollTrigger.update()
}

document.addEventListener('DOMContentLoaded', function() {
  const button = document.querySelector('.section-dillers__fixed-button');
  const container = document.querySelector('.section-dillers__fixed-button-box');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // Если кнопка пересекает контейнер (видна внутри него)
        if (entry.isIntersecting) {
          button.classList.add('static');
        } else {
          button.classList.remove('static');
        }
      });
    },
    {
      root: null, // Отслеживаем относительно viewport
      rootMargin: '0px',
      threshold: 0.1, // Срабатывает, когда 10% кнопки вошло в контейнер
    }
  );

  observer.observe(container);
});